import React from 'react';
import cn from 'classnames';
import { SlideDown } from 'react-slidedown';

import { useTranslation } from 'client/hooks';

import css from './FaqSection.module.scss';

const FaqSection = () => {
  const { translate } = useTranslation();
  const [activeFaq, setActiveFaq] = React.useState<null | number>(null);

  const clickOnFaq = (e: React.MouseEvent<HTMLDivElement>) => {
    const { index } = e.currentTarget.dataset;
    if (index) {
      if (Number(index) === activeFaq) {
        setActiveFaq(null);
      } else {
        setActiveFaq(Number(index));
      }
    }
  };

  return (
    <div className={css.contentWrapper}>
      <div className={css.title}>{translate('faqPage.title')}</div>
      <div className={css.faqs}>
        {Array.from({ length: 7 }, (v, i) => {
          return (
            <div className={cn(css.faq, i === activeFaq && css.active)} key={i}>
              <div className={css.name} data-index={i} onClick={clickOnFaq}>
                <span>{translate(`clubPage.faq.listOfQuestions[${i}].qs`)}</span>{' '}
                <div className={css.btn} data-index={i} onClick={clickOnFaq}></div>
              </div>
              <SlideDown className={css.descriptionWrapper}>
                {i === activeFaq ? (
                  <div
                    className={css.description}
                    dangerouslySetInnerHTML={{ __html: translate(`clubPage.faq.listOfQuestions[${i}].answer`) }}
                  ></div>
                ) : null}
              </SlideDown>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default FaqSection;
